import CanteenProductForm from '@/views/canteen/CanteenProductForm.vue';
import CanteenProducts from '@/views/canteen/CanteenProducts.vue';
import CanteenDashboard from '@/views/canteen/CanteenDashboard.vue';

export default [
 
  {
    path: '/canteen',
    name: 'canteen.dashboard',
    component: CanteenDashboard,
    meta: { 
      title: 'canteen.dashboardManageTitle',
      requiresAuth: true, 
      roles: ['school_admin', 'student_affairs', 'canteen'],
      requiredPerm: 'canteen_transactions.display'
    }
  },
  {
    path: '/canteen/products',
    name: 'canteen.products',
    component: CanteenProducts,
    meta: { 
      title: 'canteen.productsTitle',
      requiresAuth: true, 
      roles: ['school_admin', 'canteen'],
      requiredPerm: 'canteen_products.display'
    },
    children:[
      {
        path: 'create',
        name: 'canteen.products.create',
        component: CanteenProductForm,
        meta: { 
          title: 'canteen.productsAddTitle',
          requiresAuth: true, 
          roles: ['school_admin', 'canteen'],
          requiredPerm: 'canteen_products.create'
        }
      },
      {
        path: ':id/edit',
        name: 'canteen.products.edit',
        component: CanteenProductForm,
        meta: { 
          title: 'canteen.productsEditTitle',
          requiresAuth: true, 
          roles: ['school_admin', 'canteen'],
          requiredPerm: 'canteen_products.update'
        }
      }
    ]
  },
];
